import SocialLinks from "../components/SocialLinks";

function Contact() {
  return (
    <div>
      <h1 className="display-text" style={{ fontSize: 42, marginBottom: 32 }}>
        Contact
      </h1>
      <SocialLinks variant="page" />
    </div>
  );
}

export default Contact;
